import {store} from './store';
import authActions from '@redux/auth/actions';

export default () =>
    new Promise(() => {
        store.dispatch(authActions.checkAuthorization());
    });
